import type { TeamRole } from '../api/schemas';

/** Roles the backend invitation record can persist and acceptance can grant. */
export const INVITABLE_ROLES = [
  'org_admin',
  'iam_admin',
  'developer',
  'analyst',
  'viewer',
] as const satisfies ReadonlyArray<TeamRole>;

export function isInvitableRole(role: string): role is TeamRole {
  return (INVITABLE_ROLES as ReadonlyArray<string>).includes(role);
}
